import { render, staticRenderFns } from "./SupplierProductPriceDetails.vue?vue&type=template&id=65f0438d"
import script from "./SupplierProductPriceDetails.vue?vue&type=script&lang=js"
export * from "./SupplierProductPriceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports